var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import moment from 'moment';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as PromoCodeFactory from '../../../classes/definitions/promoCode/promoCode';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import promoCodeSchema from '../../../schemas/promoCodeSchema';
import Input from '../../UI/Input/Input';
var PromCodeForm = /** @class */ (function (_super) {
    __extends(PromCodeForm, _super);
    function PromCodeForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.brandsIDs = [];
        _this.state = {
            formConfig: _.cloneDeep(promoCodeSchema),
            formIsValid: false,
            discardPopupVisble: false,
            brandsSuggestions: [],
            categoriesSuggestions: [],
        };
        _this.getPromoCodeTypes = function () {
            _this.api
                .getPromoCodeTypes()
                .then(function (response) {
                _this.setPromoCodeTypesDropdown(_.get(response, 'data.discount_types', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка с извличане на типовете на отстъпката';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setPromoCodeTypesDropdown = function (types) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig['discount_type']);
            updatedFormElement.elementConfig.options = [];
            for (var key in types) {
                if (Object.prototype.hasOwnProperty.call(types, key)) {
                    updatedFormElement.elementConfig.options.push({
                        label: NotosService.formatPromoCodeTypes(types[key]),
                        value: types[key],
                    });
                }
            }
            _this.setState({ formConfig: updatedFormConfig });
            _this.editId = _.get(_this.props, 'match.params.id', '-1');
            if (_this.editId !== '-1') {
                _this.getPromoCode(_this.editId);
            }
        };
        _this.getPromoCode = function (id) {
            _this.api
                .getPromoCode(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на промо кода';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var promoCodeMethod = PromoCodeFactory.createPromoCodeEdit(_.get(data, 'attributes', {}));
            function formatTime(hour) {
                var formattedHour = hour < 10 ? "0" + hour : "" + hour;
                return formattedHour + ":00";
            }
            _.set(updatedFormConfig, 'code.value', promoCodeMethod.Code);
            _.set(updatedFormConfig, 'code.touched', true);
            _.set(updatedFormConfig, 'code.valid', true);
            _.set(updatedFormConfig, 'maximum_uses.value', promoCodeMethod.MaximumUses);
            _.set(updatedFormConfig, 'maximum_uses.touched', true);
            _.set(updatedFormConfig, 'maximum_uses.valid', true);
            _.set(updatedFormConfig, 'discount_type.value', promoCodeMethod.DiscountType);
            _.set(updatedFormConfig, 'discount_type.touched', true);
            _.set(updatedFormConfig, 'discount_type.valid', true);
            _.set(updatedFormConfig, 'discount_value.value', promoCodeMethod.DiscountValue);
            _.set(updatedFormConfig, 'discount_value.touched', true);
            _.set(updatedFormConfig, 'discount_value.valid', true);
            _.set(updatedFormConfig, 'only_logged_users.value', promoCodeMethod.OnlyLoggedUsers ? 'true' : 'false');
            _.set(updatedFormConfig, 'only_logged_users.touched', true);
            _.set(updatedFormConfig, 'only_logged_users.valid', true);
            _.set(updatedFormConfig, 'unique_per_user.value', promoCodeMethod.UniquePerUser ? 'true' : 'false');
            _.set(updatedFormConfig, 'unique_per_user.touched', true);
            _.set(updatedFormConfig, 'unique_per_user.valid', true);
            _.set(updatedFormConfig, 'begin_date.value', moment(promoCodeMethod.BeginDate, 'YYYY-MM-DD').toDate());
            _.set(updatedFormConfig, 'begin_date.touched', true);
            _.set(updatedFormConfig, 'begin_date.valid', true);
            // Set the formatted time in the begin_date_time field
            _.set(updatedFormConfig, 'begin_date_time.value', formatTime(Number(promoCodeMethod.BeginDateTime)));
            _.set(updatedFormConfig, 'begin_date_time.touched', true);
            _.set(updatedFormConfig, 'begin_date_time.valid', true);
            _.set(updatedFormConfig, 'end_date_time.value', formatTime(Number(promoCodeMethod.EndDateTime)));
            _.set(updatedFormConfig, 'end_date_time.touched', true);
            _.set(updatedFormConfig, 'end_date_time.valid', true);
            _.set(updatedFormConfig, 'end_date.value', moment(promoCodeMethod.EndDate, 'YYYY-MM-DD').toDate());
            _.set(updatedFormConfig, 'end_date.touched', true);
            _.set(updatedFormConfig, 'end_date.valid', true);
            _.set(updatedFormConfig, 'brand_ids.value', promoCodeMethod.BrandsName);
            _.set(updatedFormConfig, 'brand_ids.touched', true);
            _.set(updatedFormConfig, 'brand_ids.valid', true);
            _.set(updatedFormConfig, 'category_id.value', promoCodeMethod.CategoryFormatted);
            _.set(updatedFormConfig, 'category_id.touched', true);
            _.set(updatedFormConfig, 'category_id.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
                else if (event.target.value.includes(', ')) {
                    event.target.value = '';
                    updatedFormElement.value = _this.brandsIDs;
                }
            }
            else if (elType === 'inputSwitch') {
                updatedFormElement.value = event.target.value.toString();
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var promoCodeData;
            promoCodeData = PromoCodeFactory.createPromoCode({
                code: _.get(formData, 'code.value', ''),
                maximum_uses: Number(_.get(formData, 'maximum_uses.value', '')),
                discount_type: _.get(formData, 'discount_type.value', ''),
                discount_value: _.get(formData, 'discount_value.value', ''),
                only_logged_users: _.get(formData, 'only_logged_users.value', false) === 'true',
                unique_per_user: _.get(formData, 'unique_per_user.value', false) === 'true',
                begin_date: moment(_.get(formData, 'begin_date.value', '')).format('YYYY-MM-DD'),
                begin_date_time: String(_.get(formData, 'begin_date_time.value', '')),
                end_date: moment(_.get(formData, 'end_date.value', '')).format('YYYY-MM-DD'),
                end_date_time: String(_.get(formData, 'end_date_time.value', '')),
                brand_ids: _.get(formData, 'brand_ids.value', []),
                category_id: _.get(formData, 'category_id.value', null) === 0 ? null : _.get(formData, 'category_id.value', '')
            });
            if (promoCodeData.category_id === 0) {
                promoCodeData.category_id = null;
            }
            ;
            var actionMethod = _this.editId === '-1' ? _this.api.createPromoCode : _this.api.updatePromoCode;
            actionMethod({ coupon: promoCodeData }, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toPromoCodesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на промо код';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toPromoCodesPage = function () {
            _this.props.history.push(AppRoutes.promoCodes.path);
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            var searchMethod = type === 'brand_ids' ? _this.api.searchBrands : _this.api.searchCategories;
            if (type === 'brand_categories') {
                searchMethod = _this.api.searchBrandCategory;
            }
            if (type === 'brand_ids' && searchString.includes(', ')) {
                searchString = searchString
                    .replace(/(\w)\s+(\w)/g, '$1-$2') // Replace spaces between words with hyphens
                    .replace(/Dolce\s*&\s*Gabbana/gi, 'dolce-and-gabbana') // Replace "Dolce & Gabbana"
                    .replace(/Zadig\s*&\s*Voltaire/gi, 'zadig-voltaire'); // Replace "Zadig & Voltaire"
                searchMethod = _this.api.searchBrandsPost;
            }
            searchMethod(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: type === 'brand_ids'
                            ? _.get(item, 'attributes.name', '')
                            : _.get(item, 'attributes.bg_name', '') + " (" + _.get(item, 'attributes.slug', '') + ")",
                        value: _.get(item, 'id'),
                    });
                }
                // Conditionally assign results to this.brandsIDs
                if (type === 'brand_ids') {
                    _this.brandsIDs = results;
                }
                var obj = {};
                obj[type === 'brand_ids' ? 'brandsSuggestions' : 'categoriesSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    PromCodeForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        this.getPromoCodeTypes();
    };
    PromCodeForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, brandsSuggestions = _a.brandsSuggestions, categoriesSuggestions = _a.categoriesSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            _this.editId = _.get(_this.props, 'match.params.id', '-1');
            var isDisabled = [
                'code',
                'discount_type',
                'discount_value',
                'brand_promotion',
                'brand_ids',
                'category_id',
            ];
            var disabled = _this.editId !== '-1' ? isDisabled : [];
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, multiple: formElement.id === 'category_id' ? false : true, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                }, suggestions: formElement.id === 'brand_ids' ? brandsSuggestions : categoriesSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); }, disabledIds: disabled }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toPromoCodesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return PromCodeForm;
}(React.Component));
// @ts-ignore
export default withRouter(PromCodeForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/PromoCodes/PromoCodeForm/PromCodeForm.tsx
// module id = 411
// module chunks = 0